<template>
  <div class="policies">
    <p class="policies__title">Informazioni per gli ospiti</p>

    <div class="policies__content">
      <knowbefore-item
        v-for="policy in policies"
        :key="_uid + policy.key"
        :icon="policy.icon"
        :title="policy.name"
      >
        <template v-if="policy.key === 'checkin'">
          <div class="policies__item">
            <p>Dalle <strong class="semibold">{{ policy.data.begin_time }}</strong> alle
              <strong class="semibold">{{ policy.data.end_time}}</strong><br>
              Età minima per il check-In: {{ policy.data.min_age }} anni</p>
          </div>
          <div class="policies__item mt-4">
            <p class="semibold mb-2">Istruzioni per il Check-In</p>
            <div class="mb-3" v-html="policy.data.instructions" />
            <div v-html="policy.data.special_instructions" />
          </div>
        </template>

        <template v-else-if="policy.key === 'checkout'">
          <div class="policies__item">
            <p>Entro le <strong class="semibold">{{ policy.data.time }}</strong></p>
          </div>
        </template>

        <template v-else>
          <div class="policies__item" v-html="policy.data" />
        </template>
      </knowbefore-item>
    </div>
  </div>
</template>

<script>
import { build_data_items } from '@liveeps/utilities'
import KnowBeforeItem from '@liveeps/components/blocks/knowbefore/knowbefore-item'

export default {
  inheritAttrs: false,
  name: 'policies',

  props: {
    property: Object,
  },

  components: {
    'knowbefore-item': KnowBeforeItem,
  },

  data() {
    return {
    }
  },

  computed: {

    // Struttura dati: key, icon, name e content
    policies() {
      const map = [
        { key: 'checkin', icon: 'login', name: 'Check-In' },
        { key: 'checkout', icon: 'logout', name: 'Check-Out' },
        { key: 'know_before_you_go', icon: 'like', name: 'Prima di partire' }
      ]
      return build_data_items(map, this.property)
    }

  },

  created() {
  },

  mounted() {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>

  .policies {
    @extend %section;

    &__title {
      display: flex;
      align-items: center;
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      line-height: normal;
    }

    &__content {
      @extend %section__content;
      padding-top: 0;
      padding-bottom: 0;
    }
  }

</style>